import type { StateCreator } from "zustand";
import { applyIdMapping } from "../applyIdMapping";
import { INITIAL_DRAFT, type DraftLine, type DraftStoreState } from "./types";

export const createPersistenceSlice: StateCreator<
  DraftStoreState,
  [],
  [],
  Pick<DraftStoreState, "loadFromSession" | "reset" | "applyIdMap">
> = (set) => ({
  loadFromSession: (loaded) =>
    set({
      header: loaded.header,
      canvas: loaded.canvas,
      machines: loaded.machines,
      dirty: loaded.dirty,
    }),

  reset: () => set({ ...INITIAL_DRAFT }),

  applyIdMap: (idMap) =>
    set((state) => {
      const draft: DraftLine = {
        header: state.header,
        canvas: state.canvas,
        machines: state.machines,
        dirty: state.dirty,
      };
      return applyIdMapping(draft, idMap);
    }),
});
